// Per-partner page configs. Shared sections (discounts, promo slider, contact,
// footer) live in the PartnerPage template; only banner + info + big block differ.

const A = "/assets/partners";

const globalInfo = (brand) => ({
  text: `Legitimația ${brand} face parte dintr-un proiect UNESCO și este recunoscută și folosită în peste 138 de țări. ISIC este singura legitimație studențească recunoscută la nivel global. Astfel, legitimația îți va fi utilă și îți va aduce beneficii oriunde vei călători!`,
  hashtag: "#recunoscutăglobal",
});

const savingsInfo = (brand) => ({
  text: `Chiar și mai mult de 8.000 de RON poți să economisești într-un an academic cu ajutorul legitimației tale ${brand} atunci când o folosești în țară și în străinătate. Trebuie doar să o folosești cât mai des în tot ce faci. Rețeaua globală ISIC numără peste 140.000 de locații cu reduceri în 138 de țări.`,
  hashtag: "#makingstudentlifebetter",
  ron: 8000,
});

export const PARTNERS = {
  utcb: {
    slug: "utcb",
    title: "Legitimația internațională de studenți ISIC-UTCB",
    banner: { desktop: "/assets/utcb-banner-website.png", mobile: "/assets/utcb-banner-mobil.png" },
    info: [
      {
        text: "ISIC-UTCB este cea mai evoluată legitimație studențească! Toți studentii UTCB o pot obține în format plastic și digital și este legitimația oficială a studenților _Universității Tehnice de Construcții din București_ .",
        hashtag: "#legitimatiaUTCB",
      },
      globalInfo("ISIC-UTCB"),
      savingsInfo("ISIC-UTCB"),
    ],
    bigBlock: {
      heading: "Legitimația UTCB-ISIC",
      blocks: [
        { type: "p", text: "Legitimația oficială a studenților din UTCB face parte din programul International Student Identity Card (ISIC)." },
        { type: "p", text: "Legitimațiile **ISIC-UTCB** sunt emise în format plastic la începutul fiecărui an academic pentru studenții din anul I și revalidate în format digital pentru cei din anii 2+." },
        { type: "p", text: "Legitimațiile **ISIC-UTCB** pentru studenții din anul I au fost emise și pot fi ridicate în perioada **12–16 octombrie 2026**, de la standul ISIC, după următorul program:" },
        { type: "p", text: `📍 **Luni, 12 octombrie – miercuri, 14 octombrie**
Locație: Rectoratul UTCB, Bd. Lacul Tei nr. 122–124
Program: 10:00–15:00` },
        { type: "p", text: `📍 **Joi, 15 octombrie – vineri, 16 octombrie**
Locație: Facultatea de Inginerie a Instalațiilor, Bd. Pache Protopopescu nr. 66
Program: 10:00–15:00` },
        { type: "p", text: "_Dacă ești înscris(ă) în an superior (2+),_ **trebuie să îți revalidezi legitimația în format digital pentru doar 18 lei/an academic**. O poți face simplu și rapid **[AICI.](https://aplica.isic.ro/?issuer_id=109516)**" },
        { type: "p", text: "Păstrează legitimația de plastic! O vei folosi în continuare la sistemul de control acces din cămin și în curând și la cantina universității." },
      ],
    },
  },

  utm: {
    slug: "utm",
    title: "Legitimația internațională de studenți ISIC-UTM",
    banner: { desktop: `${A}/utm-desktop.png`, mobile: `${A}/utm-mobile.png` },
    info: [
      {
        text: "ISIC-UTM este cea mai evoluată legitimație studențească! Toți studentii UTM o pot obține în format digital și este legitimația oficială a studenților _Universității Titu Maiorescu din București._",
        hashtag: "#legitimatiaUTM",
      },
      globalInfo("ISIC-UTM"),
      savingsInfo("ISIC-UTM"),
    ],
    bigBlock: {
      heading: "Legitimația ISIC-UTM",
      blocks: [
        { type: "p", text: "Legitimația oficială a studenților din UTM face parte din programul International Student Identity Card (ISIC)." },
        { type: "p", text: "Orice student UTM poate aplica online pentru legitimația UTM dând click pe butonul de mai jos. Legitimația este emisă în format digital, iar asta înseamnă că o poți avea oricând cu tine în telefon!" },
        { type: "cta", label: "Aplică aici", href: "https://aplica.isic.ro/?issuer_id=118685" },
      ],
    },
  },

  usvt: {
    slug: "usvt",
    title: "Legitimația internațională de studenți ISIC-USVT",
    banner: { desktop: `${A}/usvt-desktop.png`, mobile: `${A}/usvt-mobile.png` },
    info: [
      {
        text: "ISIC – USVT este cea mai evoluata legitimatie studenteasca! Toti studentii USVT o pot obtine in format digital, in doar 3 minute!",
        hashtag: "#legitimatiaUSVT",
      },
      {
        text: "Legitimatia ISIC – USVT face parte dintr-un proiect UNESCO si este recunoscuta si folosita in peste 138 de tari. ISIC este singura legitimatie studenteasca ce este recunoscuta la nivel global. Astfel, legitimatia iti va fi utila si iti va aduce beneficii oriunde vei calatori!",
        hashtag: "#recunoscutaglobal",
      },
      {
        text: "Chiar si mai mult de 7.000 de RON poti sa economisesti intr-un an academic cu ajutorul legitimatiei tale ISIC – USVT atunci cand o folosesti in tara si in strainatate. Trebuie doar sa o folosesti cat mai des in tot ce faci. Reteaua globala ISIC numara peste 140.000 de locatii cu reduceri in 138 de tari.",
        hashtag: "#makingstudentlifebetter",
        ron: 7000,
      },
    ],
    bigBlock: {
      heading: "Legitimatia ISIC-USVT",
      intro: "Legitimatia studentilor Universitatii de Stiintele Vietii „Regele Mihai I” din Timisoara",
      blocks: [
        { type: "p", text: "Incepand cu anul academic 2023-2024, legitimatia oficiala a studentilor din USVT face parte din programul International Student Identity Card (ISIC)." },
        { type: "p", text: "Legitimatia poate fi obtinuta in format digital de catre orice student USVT si, pe langa modernizarea necesara a Student ID-ului USVT, ofera studentilor nostri si super beneficii la nivel national si global" },
        { type: "p", text: "Poti obtine legitimatia in numai 3 pasi. Simplu si rapid." },
        { type: "p", text: "1. Dai click pe butonul de comanda de mai jos" },
        { type: "p", text: "2. Completezi formularul si achiti cotizatia la un pret special pentru studentii USVT de numai 18 RON/an academic*" },
        { type: "p", text: "3. Instalezi aplicatia ISIC (Alive App) si iti activezi cardul digital" },
        { type: "p", text: "*Cotizatia se achita doar o data, la emiterea legitimatiei. Dupa un an poti sa-ti revalidezi legitimatia, prin aceeasi procedura simpla si platind aceeasi suma." },
        { type: "cta", label: "Obtine acum legitimatia ISIC-USVT", href: "https://ro-online.aliveplatform.com/ordering?partnerId=1247" },
      ],
    },
  },

  upg: {
    slug: "upg",
    title: "Legitimația internațională de studenți ISIC-UPG",
    banner: { desktop: `${A}/upg-desktop.jpg`, mobile: `${A}/upg-mobile.jpg` },
    info: [
      {
        text: "ISIC-UPG este cea mai evoluată legitimație studențească! Toți studentii UPG o pot obține în format digital și este legitimația oficială a studenților Universității de Petrol și Gaze Ploiești",
        hashtag: "#legitimatiaUPG",
      },
      {
        text: "Legitimația UPG este emisă în cadrul programului International Student Identity Card, ceea ce îi conferă recunoaștere globală ca parte a unui program UNESCO",
        hashtag: "#recunoscutăglobal",
      },
      {
        text: "Chiar și mai mult de 8.000 de RON pot fi economisiți într-un an academic cu ajutorul noii legitimații a studenților UPG.",
        hashtag: "#makingstudentlifebetter",
        ron: 8000,
      },
    ],
    bigBlock: {
      heading: "Ce este legitimația studenților Universității Petrol și Gaze din Ploiești",
      blocks: [
        { type: "p", text: "Legitimația oficială a studenților din UPG face parte din programul International Student Identity Card (ISIC). Legitimatia este emisă în format digital și poate fi utilizată prin intermediul unei aplicații de mobil dedicată." },
        { type: "p", text: "Legitimația este personalizata pentru fiecare student(ă) în parte, are un vizual unic și dedicat UPG și, de asemenea, conține și elementele European Student Card, noul program al instituțiilor europene care se adresează universităților din spațiul comunitar. În viitorul apropiat, legitimația va fi utilizată de către toți studenții pentru accesarea diferitelor servicii oferite studenților în campus, precum biblioteca UPG, cantina UPG, etc." },
        { type: "h", text: "Sunt student(ă) UPG. Cum pot să obțin legitimația UPG-ISIC?" },
        { type: "p", text: "Legitimatia digitala a Universitatii Petrol si Gaze Ploiesti este disponibila studentilor UPG ca parte a pachetului Card Like by BRD. Astfel, pentru a intra in posesia legitimatiei, studentii UPG trebuie sa aplice pentru Pachetul Card Like by BRD." },
        { type: "h", text: "Unde pot sa aplic pentru pachetul Card Like by BRD" },
        { type: "list", items: ["La standul BRD din cadrul Universitatii Petrol si Gaze", "In agentia BRD Democratiei (strada Democratiei nr.73, bloc O8, parter)"] },
        { type: "h", text: "Ce costuri implica obtinerea pachetului Card Like by BRD" },
        { type: "p", text: "Pachetul Card Like by BRD nu implica niciun cost pentru studentii UPG. Obtinerea lui este 100% GRATUITA" },
        { type: "h", text: "Ce contine pachetul Card Like by BRD" },
        { type: "list", items: [
          "Legitimatia oficiala a studentilor UPG emisa in format digital si personalizata cu datele tale",
          "Cardul de debit BRD-ISIC. Acesta este un card special si unic pentru studenti pe piata din Romania, deoarece prin intermediul sau ai acces la super reduceri in Romania cat si in alte 130 de tari la nivel global! In plus, te ajuta sa-si demonstrezi statutul de student oriunde in lume!",
          "YOU BRD – serviciul de mobile & internet banking cu zero costuri de administrare",
          "Incasari si plati gratuite",
          "Retrageri de numerar gratuite si nelimitate de la orice bancomat din Romania",
        ] },
      ],
    },
  },

  umfcd: {
    slug: "umfcd",
    title: "Legitimația internațională de studenți ISIC-UMFCD",
    banner: { desktop: `${A}/umfcd-desktop.jpg`, mobile: `${A}/umfcd-mobile.jpg` },
    info: [
      {
        text: "ISIC – UMFCD este cea mai evoluată legitimație studențească! Toți studentii UMFCD o obțin gratuit în format digital și, începând cu anul academic 2021-2022, a devenit legitimația oficială a studenților _Universității de Medicină și Farmacie „Carol Davila”._",
        hashtag: "#legitimatiaUMFCD",
      },
      globalInfo("ISIC – UMFCD"),
      savingsInfo("ISIC – UMFCD"),
    ],
    bigBlock: {
      heading: "Legitimația UMFCD-ISIC",
      blocks: [
        { type: "p", text: "Legitimația oficială a studenților din UMFCD face parte din programul International Student Identity Card (ISIC)." },
        { type: "p", text: "Legitimația este oferită gratuit tuturor studenților UMFCD și, pe lângă modernizarea necesară a student ID-ului UMC, oferă studenților noștri și super beneficii la nivel național și global!" },
        { type: "p", text: "Legitimațiile virtuale **ISIC -UMFCD** au fost deja emise pentru anul academic în curs. Acestea se activează în format digital prin intermediul aplicației de mobil Alive App ISIC." },
        { type: "p", text: "Activarea se face simplu și rapid. Tot ce trebuie să faci este să-ți verifici adresa de email personal/instituțional și să cauți mesajul primit de la ISIC România cu pașii de activare." },
        { type: "p", text: "Dacă nu ai primit e-mailul cu informațiile necesare sau întâmpini orice fel de probleme, intră pe **[isic.ro](https://www.isic.ro/)**, unde chatbotul de pe site te ajută rapid." },
      ],
    },
  },

  umc: {
    slug: "umc",
    title: "Legitimația internațională de studenți ISIC-UMC",
    banner: { desktop: `${A}/umc-desktop.jpg`, mobile: `${A}/umc-mobile.jpg` },
    info: [
      {
        text: "ISIC – UMC este cea mai evoluată legitimație studențească! Toți studentii UMC o obțin gratuit în format digital! Și, începând cu anul academic 2024-2025, a devenit legitimația studenților _Universității Maritime din Constanța._",
        hashtag: "#legitimatiaUMC",
      },
      globalInfo("ISIC – UMC"),
      savingsInfo("ISIC – UMC"),
    ],
    bigBlock: {
      heading: "Legitimația UMC-ISIC",
      intro: "Legitimația studenților Universității Maritime din Constanța",
      blocks: [
        { type: "p", text: "Legitimația oficială a studenților din UMC face parte din programul International Student Identity Card (ISIC)." },
        { type: "p", text: "Legitimația este oferită gratuit tuturor studenților UMC și, pe lângă modernizarea necesară a student ID-ului UMC, oferă studenților noștri și super beneficii la nivel național și global!" },
        { type: "p", text: "Legitimațiile virtuale **ISIC -UMC** au fost deja emise. Acestea se activează în format digital prin intermediul aplicației de mobil Alive App ISIC." },
        { type: "p", text: "Activarea se face simplu și rapid. Tot ce trebuie să faci este să-ți verifici adresa de email personal/instituțional și să cauți mesajul primit de la ISIC România cu pașii de activare." },
        { type: "p", text: "Dacă nu ai primit e-mailul și acesta nu se află nici în folderul Spam, sau întâmpini probleme la activarea legitimației, completează formularul de **[AICI](https://forms.gle/gmMsKQjWtQ9gtwYG7)**." },
      ],
    },
  },

  uauim: {
    slug: "uauim",
    title: "Legitimația internațională de studenți ISIC-UAUIM",
    banner: { desktop: `${A}/uauim-desktop.jpg`, mobile: `${A}/uauim-mobile.jpg` },
    info: [
      {
        text: "ISIC-UAUIM este cea mai evoluată legitimație studențească! Toți studentii UAUIM o pot obține în format plastic și digital și este legitimația oficială a studenților _Universității de Arhitectură și Urbanism „Ion Mincu”._",
        hashtag: "#legitimatiaUAUIM",
      },
      globalInfo("ISIC-UAUIM"),
      savingsInfo("ISIC-UAUIM"),
    ],
    bigBlock: {
      heading: "Legitimația UAUIM-ISIC",
      blocks: [
        { type: "p", text: "Legitimația oficială a studenților din UAUIM face parte din programul International Student Identity Card (ISIC)." },
        { type: "p", text: "Legitimația este emisă tuturor studenților UAUIM și, pe lângă modernizarea necesară a student ID-ului UAUIM, oferă studenților noștri și super beneficii la nivel național și global!" },
        { type: "p", text: "Legitimațiile **ISIC-UAUIM** sunt emise în format plastic la începutul fiecărui an academic pentru studenții din anul I și emise unele noi, în format digital, pentru studenții din anii 2+ (pașii de activare i-ai primit deja pe mail – caută mesajul de la ISIC România)." },
      ],
    },
  },

  ovidius: {
    slug: "ovidius",
    title: "Legitimația internațională de studenți ISIC-Ovidius",
    banner: { desktop: `${A}/ovidius-desktop.png`, mobile: `${A}/ovidius-mobile.png` },
    info: [
      {
        text: "ISIC-Ovidius este cea mai evoluată legitimație studențească! Toți studentii Ovidius o pot obține în format digital și este legitimația oficială a studenților _Universității Ovidius._",
        hashtag: "#legitimatiaOVIDIUS",
      },
      globalInfo("ISIC-Ovidius"),
      savingsInfo("ISIC-Ovidius"),
    ],
    bigBlock: {
      heading: "Legitimația ISIC-Ovidius",
      blocks: [
        { type: "p", text: "Începând cu anul academic 2025-2026, legitimația oficială a studenților din Universitatea Ovidius face parte din programul International Student Identity Card (ISIC)." },
        { type: "p", text: "Legitimația este emisă în format digital tuturor studenților Ovidius și, pe lângă modernizarea necesară a student ID-ului Ovidius, oferă studenților noștri și super beneficii la nivel național și global!" },
        { type: "p", text: "În viitorul apropiat, legitimația va putea fi utilizată de către toți studenții pentru accesarea serviciilor din campus precum cantină, bibliotecă etc." },
        { type: "h", text: "Cum se obține legitimația?" },
        { type: "p", text: "1) Te loghezi în contul tău de student Solaris și achiți taxa de 15 lei (față de taxa normală de 50 lei)" },
        { type: "p", text: "2) În termen de maxim 15 zile vei primi pe email-ul tău personal/instituțional pașii de activare a legitimației tale ISIC-Ovidius" },
        { type: "p", text: "Ai achitat taxa din Solaris pentru legitimația ISIC-Ovidius și nu ai primit email-ul de activare după 15 zile de la plată? _**[Click aici și te ajutăm noi](https://forms.gle/Waxd39JJsdUtWATY9)**_" },
      ],
    },
  },

  ase: {
    slug: "ase",
    title: "Legitimația internațională de studenți ISIC-ASE",
    banner: { desktop: `${A}/ase-desktop.png`, mobile: `${A}/ase-mobile.png` },
    info: [
      {
        text: "Începând cu anul academic 2025-2026, Academia de Studii Economice București introduce o nouă legitimație oficială a studenților. Legitimația se emite GRATUIT și va fi utilizată de către studenți atât în campusul ASE cât și în afara lui.",
        hashtag: "#legitimațiaASE",
      },
      {
        text: "Noua legitimație ASE este emisă în cadrul programului International Student Identity Card ceea ce îi conferă recunoaștere globală ca parte a unui program UNESCO",
        hashtag: "#recunoscutăglobal",
      },
      {
        text: "Chiar și mai mult de 8.000 de RON pot fi economisiți într-un an academic cu ajutorul noii legitimații a studenților ASE.",
        hashtag: "#makingstudentlifebetter",
        ron: 8000,
      },
    ],
    bigBlock: {
      heading: "Ce este noua legitimație a studenților ASE",
      blocks: [
        { type: "p", text: "Începând cu anul academic 2025-2026, Academia de Studii Economice București va avea o nouă legitimație pentru studenți. Legitimația studenților ASE este emisă în format digital și poate fi utilizată prin intermediul unei aplicații de mobil dedicată." },
        { type: "p", text: "Legitimația este personalizată pentru fiecare student(ă) în parte, are un vizual unic și dedicat ASE și, de asemenea, conține și elementele European Student Card, noul program al instituțiilor europene care se adresează universităților din spațiul comunitar." },
        { type: "h", text: "Sunt student(ă) ASE. Cum pot să obțin legitimația ASE-ISIC?" },
        { type: "p", text: "Legitimația digitală este disponibilă studenților ASE ca parte a pachetului Card Like by BRD. Astfel, pentru a intra în posesia legitimației, studenții ASE înmatriculați în anul academic 2025-2026 trebuie să aplice pentru Pachetul Card Like by BRD." },
        { type: "h", text: "Unde pot să aplic pentru pachetul Card Like by BRD" },
        { type: "list", items: ["La standul BRD din cadrul Academiei de Studii Economice", "În agenția BRD Academiei (Calea Victoriei 32-34)"] },
        { type: "h", text: "Ce costuri implică obținerea pachetului Card Like by BRD" },
        { type: "p", text: "Pachetul Card Like by BRD nu implică niciun cost pentru studenții ASE. Obținerea lui este 100% GRATUITĂ" },
        { type: "h", text: "Ce conține pachetul Card Like by BRD?" },
        { type: "list", items: [
          "Legitimația oficială a studenților ASE emisă în format digital și personalizată cu datele tale",
          "Cardul de debit BRD-ISIC. Acesta este un card special și unic pentru studenți pe piața din România, deoarece prin intermediul său ai acces la super reduceri în România cât și în alte 130 de țări la nivel global! În plus, te ajută să-ți demonstrezi statutul de student oriunde în lume!",
          "YOU BRD – serviciul de mobile & internet banking cu zero costuri de administrare",
          "Încasări și plăți gratuite",
          "Retrageri de numerar gratuite și nelimitate de la orice bancomat din România",
        ] },
        { type: "h", text: "Ce fac daca am deja pachetul Card Like by BRD" },
        { type: "p", text: "Daca esti student ASE înmatriculat în anul academic 2025-2026 și deja deții Pachetul Card Like by BRD și un card BRD-ISIC trebuie să intri și să completezi datele solicitate pe **[ACEST FORMULAR DEDICAT](https://www.isic.ro/ase)**" },
      ],
    },
  },

  uvvg: {
    slug: "uvvg",
    title: "Legitimația internațională de studenți ISIC-UVVG",
    banner: { desktop: `${A}/uvvg-desktop.jpg`, mobile: `${A}/uvvg-mobile.jpg` },
    info: [
      {
        text: "ISIC-UVVG este cea mai evoluată legitimație studențească! Toți studentii UVVG o pot obține în format plastic și digital și este legitimația oficială a studenților _Universității de Vest „Vasile Goldiș” din Arad_ .",
        hashtag: "#legitimatiaUVVG",
      },
      globalInfo("ISIC-UVVG"),
      savingsInfo("ISIC-UVVG"),
    ],
    bigBlock: {
      heading: "Legitimația UVVG-ISIC",
      blocks: [
        { type: "p", text: "Legitimația oficială a studenților din UVVG face parte din programul International Student Identity Card (ISIC)." },
        { type: "p", text: "Legitimația este emisă tuturor studenților UVVG și, pe lângă modernizarea necesară a student ID-ului UVVG, oferă studenților noștri și super beneficii la nivel național și global!" },
        { type: "p", text: "Legitimațiile **ISIC-UVVG** sunt emise în format plastic la începutul fiecărui an academic pentru studenții din anul I și revalidate în format digital pentru cei din anii 2+." },
        { type: "p", text: "_**Dacă ești înscris în anul I**_, tot ce trebuie să faci este să completezi formularul de _**[AICI](https://www.cognitoforms.com/ISICRomania/LegitimatiaISICUVVG)**_. Dacă ai completat deja acest formular, descarcă aplicația Alive App ISIC (mai jos link de download) și urmează pașii de activare primiți pe email." },
        { type: "p", text: "_**Dacă ești înscris în an superior (2+)**_, legitimația ta va fi revalidată automat la începutul fiecărui an academic. Doar trebuie să îți descarci aplicația Alive App, îți creezi cont și vei avea acces instant la legitimația digitală cu noua valabilitate, pe care o vei putea folosi să accesezi reducerile naționale/internaționale." },
        { type: "p", text: "Păstrează legitimația de plastic! O vei folosi în continuare la sistemul de control acces." },
      ],
    },
  },
};

export const PARTNER_LIST = Object.values(PARTNERS);
